import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  constructor(private oauthService: OAuthService, private router: Router) {}

  ngOnInit() {
    this.configureOAuth();
  }
 
        //issuer: 'https://openam-spark-poc.forgeblocks.com:443/am/oauth2/alpha',
      //issuer: 'https://pingfederate.dev-ual.us1.ping.cloud',
      //issuer: 'https://projectsparkapim.azure-api.net/oauth2/authorize',
      //issuer: 'https://risk-detection-router-papi.us-e1.cloudhub.io/ext/oauth2',

  private async configureOAuth() {
    const appBasePath = new URL(document.baseURI).pathname.replace(/\/$/, '');
    const redirectUri = `${window.location.origin}${appBasePath}/callback`;
    console.log('[OAuth] Using issuer:', environment.oauth.issuer, 'redirectUri:', redirectUri);

    this.oauthService.configure({
      issuer: environment.oauth.issuer,
      redirectUri,
      clientId: environment.clientId,
      responseType: 'code',
      scope: 'openid profile email',
      silentRefreshRedirectUri: redirectUri,
      useSilentRefresh: true,
      silentRefreshTimeout: 5000,
      timeoutFactor: 0.75,
      sessionChecksEnabled: false,
      clearHashAfterLogin: true,
      skipIssuerCheck: true,
      strictDiscoveryDocumentValidation: false,
      //oidc: true,
      //requestAccessToken: true
     //customQueryParams: {
       // 'acr_values': 'sparkmain',
        //'login_hint':'jamesmith@yopmail.com'
      //}
    });
    this.oauthService.setStorage(localStorage);
    this.oauthService.loadDiscoveryDocument().then(() => {
      this.oauthService.tryLogin().then(() => {

        if (this.oauthService.hasValidAccessToken()) {
          console.log(this.oauthService.getAccessToken());
          console.log(this.oauthService.getRefreshToken());
          console.log(this.oauthService.getIdToken());
          console.log(this.oauthService.getAccessTokenExpiration);
          console.log(this.oauthService.getGrantedScopes);
          console.log('User is authenticated.');
          console.log(this.router.url);
          
          if(this.router.url.includes("/callback")) this.router.navigate(["/"])
        } else {
          console.log('User is not authenticated.');
        }
      })
      .catch((err) => {
        console.log('Error during OAuth flow:', err);
      });
    })
    .catch((err) => {
      console.log('Error loading OIDC discovery document:', err);
    });
    

  }
  
  
}